import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustRow from './components/TrustRow';
import PainPromise from './components/PainPromise';
import Benefits from './components/Benefits';
import SocialProof from './components/SocialProof';
import Pricing from './components/Pricing';
import Comparison from './components/Comparison';
import ObjectionBust from './components/ObjectionBust';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-slate-900 transition-colors duration-300">
        <Header />
        <Hero />
        <TrustRow />
        <PainPromise />
        <Benefits />
        <SocialProof />
        <Pricing />
        <Comparison />
        <ObjectionBust />
        <Footer />
        <FloatingCTA />
      </div>
    </ThemeProvider>
  );
}

export default App;